import {NgModule} from "@angular/core";
import {ReactiveFormsModule} from "@angular/forms";
import {QRCodeComponent} from "angularx-qrcode";
import {FlatWidgetButtonComponent} from "../shared/components/flat/flat-widget-button/flat-widget-button";
import {SharedModule} from "./../shared/shared.module";
import {AcceptInviteComponent} from "./accept-invite/accept-invite.component";
import {FilterComponent} from "./filter/filter.component";
import {LoginComponent} from "./login.component";
import {OverViewComponent} from "./overview/overview.component";
import {RegistrationModule} from "./registration/registration.module";
import {LoadingScreenComponent} from "./shared/loading-screen";
import {SumStateComponent} from "./shared/sumState";
import {SiteCreateSuccessComponent} from "./site-create/site-create-success.component";
import {SiteCreateComponent} from "./site-create/site-create.component";

@NgModule({
  imports: [
    SharedModule,
    RegistrationModule,
    FlatWidgetButtonComponent,
    FilterComponent,
    ReactiveFormsModule,
    QRCodeComponent,
  ],
  declarations: [
    SumStateComponent,
    LoginComponent,
    OverViewComponent,
    LoadingScreenComponent,
    SiteCreateComponent,
    SiteCreateSuccessComponent,
    AcceptInviteComponent,
  ],
})
export class IndexModule {
}
